export default {
  nav: {
    portfolio: "Widyo的作品集",
    whyme: "为什么选择我？",
    education: "教育",
    experience: "经验",
    organizational: "组织",
    events: "活动",
    portfolio_link: "作品集",
    skills: "技能",
    certificates: "证书",
    awards: "奖项和认证",
    contact: "联系",
    downloadResume: "下载简历",
    downloadPortfolio: "下载作品集",
    letsConnect: "让我们联系",
  },
  hero: {
    greeting: "你好！",
    name: "我是Widyo Tri Cahya Utomo",
    nickname: "Dio",
    title: "DevOps 工程师 | 数据工程师",
    description: "Apple Developer Institute 的 DevOps 工程师，使用 Terraform 和 Ansible 将 AWS 基础设施自动化为代码，并构建 CI/CD 管道。以三年企业数据工程经验为基础——ETL/CDC、云迁移与数据平台。",
    downloadResume: "下载简历",
    contactMe: "联系我",
  },
  whyme: {
    title: "为什么选择我？",
    subtitle: "作为 DevOps 工程师，我的与众不同之处",
    content: "我不仅仅是移动数据——我将其转化为创造真正商业价值的智能。我以好奇的怀疑态度处理每个问题，验证假设并设计可扩展、可靠且真正产生成果的系统。我的经验涵盖端到端数据工程，包括摄取、仓储、编排、治理以及跨现代技术栈的性能调优。我曾在失败不是选项的企业环境中工作，因此可靠性、安全性和精确性是不可妥协的。我痴迷于简洁的架构、高效的管道和能够预防问题而不是制造问题的自动化。凭借40多个行业认证以及对AI和Web3的前瞻性关注，我构建的系统旨在满足今天的需求和明天的创新。简而言之，我提供为影响、规模和未来而构建的数据解决方案。",
  },
  tools: {
    title: "以下是我每天使用的一些工具和技术",
  },
  education: {
    title: "教育",
    subtitle: "计算机工程学术基础，重点关注数据系统",
    graduated: "毕业",
    institutions: {
      maranatha: {
        name: "Maranatha基督教大学",
        degree: "工学学士(B.E.)，计算机工程",
        highlights: [
          "GPA: 3.83",
          "相关课程：数据库、操作系统、计算机网络",
        ],
      },
      yosuka: {
        name: "Yos Sudarso高中 - 卡拉旺",
        degree: "数学和科学专业",
        status: "高中文凭",
      },
      akademicrypto: {
        name: "Akademi Crypto - 丹格朗",
        degree: "Web3和区块链非学位课程",
        status: "2024年3月 - 至今",
        highlights: [
          "专注于Web3、区块链基础和去中心化技术",
          "积极学习加密经济学、智能合约和DeFi生态系统",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - 雅加达",
        degree: "金融交易和市场分析非学位课程",
        status: "2025年9月 - 至今",
        highlights: [
          "专注于使用基本面分析和技术分析进行加密货币交易",
          "通过社区学习开发实用交易策略和市场评估技能",
        ],
      },
    },
  },
  experience: {
    title: "经验",
    subtitle: "云基础设施自动化，以及跨各行业的企业数据工程和技术咨询",
  },
  organizational: {
    title: "组织与社区",
    subtitle: "在专业组织和社区中的领导角色和积极参与",
    activities: [
      {
        title: "大学领导",
        organization: "Maranatha基督教大学",
        role: "数字计算机实验室主管",
        dates: "2021年4月 - 2023年4月",
        description: "领导实验室，管理项目和学生指导。",
      },
      {
        title: "加密社区",
        organization: "Akademi Crypto、TradeWithSuli、Coin Kami",
        role: "活跃成员",
        dates: "2023年2月 - 至今",
        description: "Web3和加密社区的积极参与者和终身学习者。",
      },
      {
        title: "联系小组和多媒体事工",
        organization: "玫瑰沙龙教会",
        role: "活跃成员",
        dates: "2015年8月 - 至今",
        description: "通过联系小组团契和多媒体事工积极参与教会社区，支持崇拜服务和创意媒体制作。",
      },
    ],
  },
  events: {
    title: "活动与画廊",
    subtitle: "活动、会议、研讨会和专业活动的照片和亮点",
    noImages: "没有图片",
    maintenance: "维护中",
    maintenanceDesc: "此部分目前正在更新新内容。请稍后查看！",
  },
  portfolio: {
    title: "作品集",
    subtitle: "展示Web开发和数据工程工作的精选项目",
    webPortfolioTitle: "Web作品集",
    dataPortfolioTitle: "数据工程作品集",
    viewLive: "查看实况",
    explore: "探索",
    showMore: "显示更多",
    showLess: "显示较少",
    downloadPdf: "下载作品集PDF",
    generatingPdf: "正在生成PDF...",
    selectProjects: "选择项目",
    selectAll: "全选",
    cancel: "取消",
    downloadSelected: "下载",
    webProjects: [
      {
        title: "Maju Cipta Karya网站",
        description: "Maju Mapan是一个融合优雅设计与可持续性的现代家具品牌。每件作品都由当地工匠使用环保材料手工制作，为每个生活空间带来舒适、平衡和温暖。",
      },
      {
        title: "Tcuber Store网站",
        description: "Tcuber Store是印度尼西亚值得信赖的在线游戏充值平台，为Mobile Legends、Free Fire、Roblox、Genshin Impact、Clash of Clans和PUBG Mobile等热门游戏提供快速、安全且经济实惠的数字点数。我们提供多种支付方式和快速响应的支持，确保流畅的游戏体验。",
      },
    ],
    dataProjects: [
      {
        title: "AI企鹅数据分析",
        description: "AI驱动的交互式数据探索工具。使用自然语言问题分析企鹅物种数据，并通过动态图表可视化洞察。使用React、Recharts和Lovable AI构建。",
      },
    ],
    penguinExplorer: {
      title: "询问企鹅",
      selectQuestion: "您想了解什么？",
      submit: "提交",
      analyzing: "分析中...",
      thinking: "思考中...",
      errorLoading: "加载企鹅数据时出错",
      errorAnalyzing: "分析数据时出错",
      rateLimitError: "超出速率限制。请稍后再试。",
      paymentError: "需要付款。请向您的Lovable AI工作区添加积分。",
      speciesDistribution: "物种分布",
      billVsBody: "喙长与体重",
      dataTable: "数据预览",
      questions: [
        "哪些企鹅的喙最长？",
        "最重的企鹅住在哪里？",
        "哪些企鹅的鳍最短？",
      ],
    },
  },
  skills: {
    title: "技能",
    subtitle: "以企业数据工程为基础的云基础设施、自动化与 CI/CD",
    categories: {
      cloud: "云与基础设施",
      iac: "IaC 与 GitOps",
      cicd: "CI/CD",
      containers: "容器与可观测性",
      security: "安全与网络",
      databases: "数据库",
      etl: "ETL 与集成",
      programming: "编程",
      soft: "软技能",
    },
  },
  certificates: {
    title: "Dataiku证书",
    subtitle: "Dataiku的数据科学、机器学习和AI专业认证",
    clickToView: "点击查看完整证书",
    download: "下载",
    verify: "验证",
    preview: "证书预览",
  },
  awards: {
    title: "奖项和认证",
    subtitle: "数据平台、云基础设施和AI技术的专业认证",
    view: "查看",
  },
  contact: {
    title: "联系我们",
    subtitle: "欢迎机会、合作和演讲请求",
    info: "联系信息",
    email: "电子邮件",
    phone: "电话",
    social: "社交媒体",
    sendMessage: "发送消息",
    name: "姓名",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "消息",
    messagePlaceholder: "Masukkan pesan",
    send: "发送消息",
    copyright: "© 2025 Widyo Tri Cahya Utomo. 保留所有权利。",
  },
  whatsapp: {
    title: "联系我们",
    subtitle: "选择您想要联系的方式",
    chatbot: "与AI助手聊天",
    whatsapp: "通过WhatsApp发送消息",
    defaultMessage: "你好Widyo！我想与您联系。",
  },
  chatbot: {
    title: "AI助手",
    welcome: "你好！我是Widyo的AI助手。我可以回答关于他的经验、技能和项目的问题。我能帮你什么？",
    placeholder: "输入您的消息...",
    error: "抱歉，遇到错误。请重试。",
  },
};
